var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("サイト上には「検索条件」及び「更新日時が新しい案件」に基づいて表示されます")]),_c('p',[_vm._v("(C)PreciousPartnersCo.,Ltd.")])])}]

export { render, staticRenderFns }